
import ReactDOM from 'react-dom';
import ShapePickMenu from '../shape-pick-menu/index';
import AlloyTouch from '@tencent/docs-scenario-components/src/utils/alloytouch';
import { isPortrait } from '@src/js/common/utils';
import  React from 'react';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import './style/index.less';

const WIDE_MODE_WIDTH = 640;

interface MobilePullablePanelProps {
    resetWhenUpdate?: boolean;
    isCloseable?: boolean;

    onHide?: (panel?) => void;
    onShow?: (panel?) => void;
    preferredHeight: number;
}

interface MobilePullablePanelState {
    isShown: boolean;
}

/**
 * 可上下拉动的半屏面板
 */
export default class MobilePullablePanel extends React.Component<MobilePullablePanelProps, MobilePullablePanelState> {
    public static _layer = null;
    public static _instance = null;

    public static createMenu(config, onMenuItemClickCallBack?) {
        const div = document.createElement('div');
        div.id = 'popup-menu-container-id';
        document.body.appendChild(div);

        let currentConfig = {
            ...config,
            itemClickCallBack: onMenuItemClickCallBack,
        };
        // eslint-disable-next-line
        const MenuInstance = ReactDOM.render(<MobilePullablePanel {...currentConfig} />, div) as unknown as MobilePullablePanel;

        function show(newConfig, onMenuItemClickCallBack) {
            if (onMenuItemClickCallBack) {
                currentConfig = {
                    ...currentConfig,
                    ...newConfig,
                    itemClickCallBack: onMenuItemClickCallBack,
                };
            } else {
                currentConfig = {
                    ...currentConfig,
                    ...newConfig,
                };
            }

            if (MenuInstance) {
                MenuInstance.show();
            }
        }

        function hide() {
            if (MenuInstance) {
                MenuInstance.hide();
            }
        }


        return { show, hide };
    }
    private mask: React.RefObject<HTMLDivElement>;
    private panel: React.RefObject<HTMLDivElement>;
    private scroller: React.RefObject<HTMLDivElement>;
    private wrapper: React.RefObject<HTMLDivElement>;
    private wideModeTriangle: React.RefObject<HTMLDivElement>;
    private innerWidth: number;
    private innerHeight: number;
    private touch: AlloyTouch;
    public constructor(props) {
        super(props);

        this.state = {
            isShown: false,
        };

        this.mask = React.createRef();
        this.panel = React.createRef();
        this.scroller = React.createRef();
        this.wrapper = React.createRef();
        this.wideModeTriangle = React.createRef();
        this.innerWidth = Math.min(window.innerWidth, window.innerHeight);
        this.innerHeight = Math.max(window.innerWidth, window.innerHeight);
    }

    public componentDidMount = () => {
        const mask = this.mask.current;
        if (!mask) {
            return;
        }

        mask.addEventListener('contextmenu', e => e.preventDefault());
        mask.addEventListener('mousedown', (e) => {
            if (e.target === mask) {
                this.hide();
            }
        });
        let hasMove = false;

        // 这个 AlloyTouch 是个特别定制版，不要用别的版本
        this.touch = new AlloyTouch({

            // 整个蒙层内触摸都可以滑动
            touch: mask,
            vertical: true,

            // 向上滑动，原始值（纵坐标）减小，响应值（高度）增大
            reverse: true,

            // 左右方向的滑动也响应，否则滑动角度不对的时候会卡住
            lockDirection: false,

            // 动画属性不直接映射到某个 DOM 属性，而是映射到 this.value，在 setter 中会具体定义这个 value 的用法
            target: this,
            property: 'value',
            bindSelf: true,

            // 初状态
            initialValue: this.defaultHeight,

            // 减速系数稍大一些，防止惯性滚动太块
            deceleration: 0.003,

            // AlloyTouch 的最小值和最大值是指回弹的位置
            min: () => this.minHeightForAlloyTouch,
            max: () => this.maxHeightForAlloyTouch,

            // 当前是否需要回弹，注意，AlloyTouch 的 “不回弹” 并不会 “瞬间回跳”，而是卡在原地不动。
            shouldRebound: (height) => {
                // 非宽屏下，当已经滑动到最小值，再向下滑动距离超过 70，则动画关闭面板
                if (!this.isWideMode && height < this.minHeightForPanel - 70) {
                    this.hide();
                    return false;
                }

                // 其他情况按默认处理
                return true;
            },

            // 点击事件，如果是点击蒙层，则动画关闭面板
            // 这里的蒙层相当于代理关闭
            tap: (e) => {
                if (e.target === mask && e.type !== 'touchcancel') {
                    this.hide();
                    e.stopPropagation();
                    e.preventDefault();
                }
            },

            touchStart: () => {
                hasMove = false;
                // 产品要求开始滑动时不能闪现点击态，按着才有点击态，这不是为难我胖虎吗
                // 这种问题一般只能延迟一段时间，看这段时间内有没有滑动，没有滑动的话，才开始允许内部点击态
                // 在实现方式上，如果用事件捕获来实现，根据延时时间内是否移动来控制事件是否进入面板内部，
                // 由于没有滑动的时候不会产生新的事件，会导致延时过后不会立即出现点击态，因此不能用这种方法
                // 因此只能用 CSS 的办法，在外侧给一个 class 来提示内部是否可以出现点击态
                setTimeout(() => {
                    if (!hasMove) {
                        this.panel.current?.classList.add('nomove'); // 开始允许点击态
                    }
                }, 100);
            },

            touchMove: () => {
                hasMove = true;
                this.panel.current?.classList.remove('nomove'); // 开始滑动，不再允许点击态
            },

            touchEnd: () => {
                // iOS 会在 touchstart 之前就判断是否进入 active 态，如果我们在 touchstart 的时候才去掉这个 class 就为时已晚了
                // 所以在没触摸之前的空闲状态就应该是不允许点击态的，这样 iOS 在开始点击时才不会立即判断为出现点击态
                this.panel.current?.classList.remove('nomove'); // 结束触摸，不再允许点击态，以防下一次 iOS touchstart 出现点击态
            },
        });

        this.reset();

        window.addEventListener('resize', this.reset);
    };

    public componentWillUnmount() {
        window.removeEventListener('resize', this.reset);
    }

    public componentDidUpdate() {
        // 是否需要数据变化时更新到初始位置，比如二级菜单
        if (this.props.resetWhenUpdate) {
            this.touch?.to(this.defaultHeight, 250);
        }
    }

    public show = () => {
        this.setState({ isShown: true });
        this.touch?.to(this.defaultHeight, 250);
        this.props.onShow?.(this);
    };

    public hide = () => {
        if (this.props.isCloseable !== false) {
            this.setState({ isShown: false });
            this.props.onHide?.(this);
            setTimeout(() => {
                if (this.mask.current?.parentElement) {
                    const popupContainer = this.mask.current.parentElement;
                    ReactDOM.unmountComponentAtNode(popupContainer);
                    popupContainer.remove();
                }
            }, 300);
        }
    };

    public render = () => (
        <div className={`mobile-pull-panel-mask ${this.state.isShown ? '' : 'mobile-pull-panel-hidden'}`} ref={this.mask}>
            <div className={`mobile-wide-mode-triangle ${this.state.isShown && this.isWideMode ? 'show' : ''}`} ref={this.wideModeTriangle}></div>
            <div className="mobile-pull-panel" ref={this.panel}>
                <div className="mobile-pull-panel-children-scroller" ref={this.scroller} onWheel={this.handleWhell}>
                    <div className="mobile-pull-panel-children-wrapper" ref={this.wrapper}>
                        <ShapePickMenu {...this.props} hide={this.hide} />
                    </div>
                </div>
                {this.props.isCloseable !== false && <div className="mobile-pull-panel-btn-close" onClick={this.hide} />}
            </div>
        </div>
    );

    // 竖屏模式 = (手机 && 竖屏) = (宽度 < 512)  （保留现在的规则）
    // 竖屏旋转模式 = (平板 || 横屏) = ( 512 < 宽度 <= 640) （展示2个半高度）
    // 宽屏模式 = (平板 || 横屏) = (宽度 > 640) （展示浮窗）
    // 独立 APP 有个坑：resize 事件结束后 window.innerWidth 不会立即改变
    private get isWideMode() {
        if (browser.isIOS && browser.isQQMiniProgram) {
            // qq小程序里旋转横屏再竖屏后，获取宽度会不及时。
            return (isPortrait() ? this.innerWidth : this.innerHeight) > WIDE_MODE_WIDTH;
        }
        return Math.max(window.innerWidth, document.body.offsetWidth) > 640;
    }

    private get isRotateMode() {
        return !isPortrait();
    }

    // 解析设置的初始高度
    private get preferredHeight() {
        return this.props.preferredHeight || window.innerHeight / 2;
    }

    // 面板允许收缩的最小高度
    // 当内容少于半屏，取内容高度为最小高度；
    // 当内容多于半屏，取半屏高度为最小高度。
    // 宽屏模式下，最小高度就在回弹位置，最大高度也在回弹位置，这样就禁掉了滑动手势。
    private get minHeightForPanel() {
        if (this.isWideMode) {
            return this.maxHeightForPanel;
        }
        return Math.min(
            this.preferredHeight,
            this.wrapper.current ? this.wrapper.current.clientHeight : 0,
        ) + 24;
    }

    // 面板允许展开的最大高度
    private get maxHeightForPanel() {
        return Math.min(
            this.maxHeightForRebound, // - 54,
            this.maxHeightForContent,
        );
    }

    // 带内容的最大高度，也就是当面板展开到最大，而且内容也滚动到最底部，此时就要回弹了
    private get maxHeightForContent() {
        return (this.wrapper.current ? this.wrapper.current.clientHeight : 0) + 24;
    }

    // 面板加橡皮筋弹性，总共允许达到的最大高度，当越界弹性达到了这个高度，就要卡住，不能再弹了
    private get maxHeightForRebound() {
        // 宽屏模式下，最大高度等于总高度 - 工具栏高度 54 - 适当的底部留白（iPhone X 等）
        if (this.isWideMode) {
            // return window.innerHeight - 65- 8;
            // 设计给的稿子是302
            return 302;
        }
        return window.innerHeight;
    }

    // 给 AlloyTouch 用的最小高度（越界回弹点）
    private get minHeightForAlloyTouch() {
        if (this.isWideMode) {
            // 宽屏模式下，因为触摸和弹性全都给内部滚动，所以直接用内容滚动量的最小值 0 作为回弹点
            return 0;
        }
        // 窄屏模式下，面板收缩到最小的时候，就要有弹性了，所以用面板最小高度作为回弹点
        return this.minHeightForPanel;
    }

    // 给 AlloyTouch 用的最大高度（越界回弹点）
    private get maxHeightForAlloyTouch() {
        if (this.isWideMode) {
            // 宽屏模式下，因为触摸和弹性全都给内部滚动，面板高度固定不变，所以直接用内容滚动量的最大值（内高度 - 外高度）作为回弹点
            return this.maxHeightForContent - this.maxHeightForPanel;
        }
        // 窄屏模式下，当面板展开到最大，而且内容也滚动到最底部，此时就要回弹了，这个值作为回弹点
        return this.maxHeightForContent;
    }

    // 面板打开时（包括 AlloyTouch 初始化时、以及每次调用 show 时）的初始高度
    private get defaultHeight() {
        // 旋转模式，初始高度不一致,展示2个半高度
        if (this.isRotateMode) {
            return this.minHeightForPanel;
            // return Math.min(this.preferredHeight, this.minHeightForPanel, 205);
        }
        // 宽屏模式下，面板最小高度和最大高度相等；窄屏模式下，打开时默认为最小高度。
        return Math.min(this.maxHeightForPanel, Math.max(this.minHeightForPanel, this.preferredHeight));
    }

    // 初始化、旋转屏幕、尺寸变化时，重置面板高度和滚动量
    private reset = () => {
        setTimeout(() => {
            if (this.isWideMode) {
                // 宽屏模式下，内部滚动量被 AlloyTouch 直接接管，回到初始值 0；面板高度脱离 AlloyTouch 控制，回到默认高度。
                this.touch?.to(0, 250);
                if (this.panel.current) {
                    if (browser.isWideScreenDevice) {
                        this.panel.current.style.height = `${Math.floor(window.innerHeight * 0.75)}px`;
                    } else {
                        this.panel.current.style.height = `${this.defaultHeight}px`;
                    }
                    this.panel.current.classList.remove('sticky');
                }

                // 旋转宽屏的时候，需要展示箭头
                if (this.wideModeTriangle.current?.classList) {
                    this.wideModeTriangle.current.classList.add('show');
                }
            } else {
                // 窄屏模式下，面板高度受到 AlloyTouch 控制，内部滚动量受到间接控制，暂时回零。
                this.touch?.to(this.defaultHeight, 250);
                this.scroller?.current && (this.scroller.current.scrollTop = 0);
                // 窄屏的时候，隐藏箭头
                if (this.wideModeTriangle.current?.classList) {
                    this.wideModeTriangle.current.classList.remove('show');
                }
            }
        }, 0);
    };

    // 取 AlloyTouch 运动值
    private get value() {
        if (!this.scroller) return 0;
        if (this.isWideMode) {
            // 宽屏模式下，AlloyTouch 直接控制内容区域滚动，滚动量就是运动值本身
            return this.scroller.current ? this.scroller.current.scrollTop : 0;
        }
        // 窄屏竖屏模式下，AlloyTouch 分段控制面板高度和内容区域滚动，把这两个加起来才是运动值
        if (!this.panel.current || !this.scroller.current) {
            return 0;
        }
        // console.log("get" + parseFloat(this.panel.current!.style.height || '') + this.scroller.current!.scrollTop);
        return parseFloat(this.panel.current.style.height || '') + this.scroller.current.scrollTop;
    }

    // 设置 AlloyTouch 运动值
    private set value(value) {
        if (!this.scroller?.current || !this.panel.current) return;
        // console.log("set" + value);
        if (this.isWideMode) {
            // 宽屏模式下，滑动只给内容区域滚动用，而且不用边界检查，直接把弹性留给滚动区域内部即可。
            this.scroller.current.scrollTop = value;
        } else {
            // 手机竖屏模式下，滑动分为三个阶段：面板展开高度 + 面板无法再展开时的内容滚动量 + 内容无法再滚动时面板发生橡皮筋弹性的额外高度

            // 1. 先看是否超过面板回弹位置，未超过回弹位置的部分，初步设置为面板展开高度；
            let height = Math.min(value, this.maxHeightForPanel);

            // 2. 超过回弹位置，面板无法再展开，但内容仍然可滚动时，设置为内容区域的滚动量；
            this.scroller.current.scrollTop = Math.min(
                this.maxHeightForContent,
                Math.max(0, value - this.maxHeightForPanel),
            );

            // 3. 面板无法再展开，内容也无法再滚动时，剩下的额外高度，仍然给面板，作为橡皮筋弹性。
            height += Math.max(0, value - this.maxHeightForContent);

            // 最终面板高度由未超过回弹位置的高度和超过内容区域高度两部分组成。
            this.panel.current.style.height = `${height}px`;

            // 如果窄屏模式下高度达到了最大高度，添加吸附状态的 class
            if (!this.isWideMode && value >= this.maxHeightForRebound) {
                this.panel.current.classList.add('sticky');
            } else {
                this.panel.current.classList.remove('sticky');
            }
        }
    }

    private handleWhell = (e) => {
        e.preventDefault();
    };
}
